module.exports = __webpack_public_path__ + "static/media/arrowdown-newhomepage.3e9f84ae.svg";